<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" :hide-button="true" />

      <div class="row">
        <div class="col d-flex">
          <div class="col-7 d-flex flex-column">
            <div class="col">
              <b-form>
                <b-form-group label="Conveniado">
                  <b-form-input @focus="showConveniadoFilter = true" name="filterConveniado"
                    v-model="filterConveniadoText"></b-form-input>
                  <div class="filtered-select" v-if="showConveniadoFilter">
                    <ul>
                      <li v-for="conveniado of filteredConveniados" :key="conveniado._id"
                        @click="selectConveniado(conveniado)">{{ conveniado.nome }}</li>
                    </ul>
                  </div>
                </b-form-group>
              </b-form>
            </div>
            <div class="col">
              <b-form>
                <b-form-group label="Local">
                  <b-form-input v-model="unidadeSelected"></b-form-input>
                </b-form-group>
              </b-form>
            </div>
            <div class="col">
              <b-form>
                <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" value="cancelado"
                  :unchecked-value="false">
                  Cancelados
                </b-form-checkbox>
              </b-form>
            </div>
            <div class="col-12 mt-2">
              <div class="row">
                <b-badge class="ml-2 mt-2 text-left font-large" v-for="(item, index) in conveniadoSelected.limite"
                  :key="index" variant="primary">

                  <span v-if="item.unidade.trim() === 'online'">
                    Unidade: {{ item.unidade }} <br><br>
                    Limite Consulta: {{ item.limite_consulta }} <br><br>
                    Limite Retorno: {{ item.limite_retorno }}
                  </span>
                </b-badge>
              </div>
            </div>
          </div>
          <div class="col-3">
            <b-button @click="calendarShow = !calendarShow" class="
                d-flex
                align-items-center
                justify-content-center
                btn-lg btn-block
              " :disabled="!conveniadoSelected">
              <feather type="calendar" class="mr-2"></feather>Calendário
            </b-button>
            <b-form-group>
              <b-calendar v-show="calendarShow" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" class="absolute" :date-info-fn="dateClass" locale="pt-br" v-model="dateSelected"
                :disabled="!conveniadoSelected"></b-calendar>
            </b-form-group>
          </div>
          <div class="col-2 d-flex flex-column">
            <b-button class="mb-2" @click="loadAgenda"> Buscar </b-button>
            <b-button v-if="!(user.tipo == 'verificador')" :disabled="!conveniadoSelected ||
              !conveniadoSelected.not_generate_preschedule
              " @click="openModal">
              Inserir
            </b-button>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <b-table hover :fields="agendaMedicaFields" :items="agenda" :per-page="10">
            <template v-slot:cell(cliente)="row">
              {{
                findDependente(row.item.dependente, row.item)
                  ? findDependente(row.item.dependente, row.item).dependente
                  : row.item.cliente
                    ? row.item.cliente.nome
                    : ''
              }}
            </template>
            <template v-slot:cell(procedimento)="row">
              <div v-if="row.item.procedimento">
                <p v-for="(item, index) of row.item.procedimento" :key="index">
                  {{ item.descricao }}
                </p>
              </div>
            </template>
            <template v-slot:cell(dataHora)="row">
              {{ formatDate(row.item.dataHora) }}
            </template>
            <template v-slot:cell(editar)="row" v-if="!(user.tipo == 'verificador')">
              <button v-b-tooltip.hover title="Editar" type="button" class="btn btn-light"
                v-if="user.tipo !== 'secretaria_conveniado'" @click="modalEdit(row.item)">
                <i class="uil uil-edit-alt"></i>
              </button>
              <button v-b-tooltip.hover title="Cancelar" type="button" class="btn btn-light"
                v-if="user.tipo !== 'secretaria_conveniado'" @click="modalDelete(row.item._id)">
                <i class="uil uil-trash-alt"></i>
              </button>
              <button v-if="row.item.status !== 'confirmado'" v-b-tooltip.hover title="Confirmar" type="button"
                class="btn btn-light" @click="modalConfirmarAgenda(row.item)">
                <i class="uil uil-check"></i>
              </button>
              <button v-if="row.item.retorno && !row.item.retornado" v-b-tooltip.hover title="Retorno Disponível"
                type="button" class="btn btn-light" @click="modalRetorno(row.item)">
                <i class="uil uil-arrow-left"></i>
              </button>
            </template>
            <template v-slot:cell(status_atendimento)="row">
              <b-form-select v-model="row.item.status_atendimento" :options="options"
                @change="updateStatus(row.item._id, row.item.status_atendimento)"></b-form-select>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="10"></b-pagination>
        </div>
      </div>
    </div>

    <b-modal hide-footer centered size="lg" id="autorizacaoProcedimento" title="Relatorio">
      <div class="d-flex mb-3">
        <b-button class="mr-3 mt-3" block @click="print('autorizacao')">
          <feather type="printer" class="align-middle"></feather>
          Imprimir
        </b-button>
        <b-button class="mt-3" block @click="generateReport('relAutorizacaoProcedimentoPDF')">Salvar em PDF</b-button>
      </div>
      <div class="d-block">
        <div class="d-block">
          <rel-autorizacao-procedimento :agendamento="confirmAgendamento"></rel-autorizacao-procedimento>
        </div>
        <VueHtml2pdf :manual-pagination="true" :enable-download="true" ref="relAutorizacaoProcedimentoPDF"
          v-show="false" :html-to-pdf-options="htmlToPdfOptions">
          <section slot="pdf-content">
            <rel-autorizacao-procedimento :agendamento="confirmAgendamento"></rel-autorizacao-procedimento>
          </section>
        </VueHtml2pdf>
      </div>
    </b-modal>

    <b-modal id="calendario" centered title="Calendario">
      <b-form-group>
        <b-form-input v-model="conveniadoSelected.nome" disabled></b-form-input>
      </b-form-group>
      <v-date-picker :key="dateSelected" mode="date" :timezone="timezone" :attributes="attributes"
        :model-config="modelConfig" v-model="dateSelected" is-expanded>
        <template v-slot:day-popover>
          <div> 8:00 - Itabela - Paciente: Fulano de tal </div>
          <div> 8:30 - Itabela - Paciente: Ciclano </div>
        </template>
      </v-date-picker>
    </b-modal>

    <b-modal size="lg" id="novo-agendamento" centered
      :title="(this.formAgendamento._id ? 'Editar' : 'Novo') + ' Agendamento'" hide-footer hide-header-close>
      <div class="d-flex flex-column">

        <b-row>
          <div class="col-6">
            <b-form-group label="Cliente">
              <b-form-input :state="validateState('cliente')" :class="{
                'is-invalid': formsubmit && $v.formAgendamento.cliente.$error,
              }" @focus="showClienteFilter = true" @input="listandoClientes" v-model="paramFilterCliente"
                placeholder="Digite o nome do cliente"></b-form-input>

              <!-- Dropdown de clientes filtrados -->
              <div class="filtered-select" v-if="showClienteFilter && filteredClientes.length">
                <ul>
                  <li v-for="cliente in filteredClientes" :key="cliente._id" @click="selectCliente(cliente)">
                    {{ cliente.nome }} <!-- Exibe o nome do cliente -->
                  </li>
                </ul>
              </div>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Conveniado">
              <b-form-input :disabled="!clienteRoute" :state="validateState('conveniado')" :class="{
                'is-invalid': formsubmit && $v.formAgendamento.conveniado.$error,
              }" @focus="showFormConveniadoFilter = true" @blur="showFormConveniadoFilter = false"
                name="filterConveniado" v-model="filterConveniadoText"></b-form-input>
              <div class="filtered-select" v-if="showConveniadoFilter">
                <ul>
                  <li v-for="conveniado of filteredConveniados" :key="conveniado._id"
                    @click="selectConveniado(conveniado)">
                    {{ conveniado.nome }}</li>
                </ul>
              </div>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <div class="col-6">
            <b-form-group label="Unidade">
              <b-form-select v-model="formAgendamento.unidade" :options="unidadesConveniado"
                :state="validateState('unidade')" :class="{
                  'is-invalid': formsubmit && $v.formAgendamento.unidade.$error,
                }"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Especialidade">
              <b-form-select :state="validateState('especialidade')" :class="{
                'is-invalid':
                  formsubmit && $v.formAgendamento.especialidade.$error,
              }" v-model="formAgendamento.especialidade" disabled :options="especialidades">
              </b-form-select>
            </b-form-group>
          </div>
        </b-row>
        <b-form-group label="Procedimento" v-if="formAgendamento.conveniado && formAgendamento.cliente">
          <div v-if="typeof filterProcedimentoText === 'string'">
            <b-form-input v-model="filterProcedimentoText" :state="validateState('procedimento')" :class="{
              'is-invalid':
                formsubmit && $v.formAgendamento.procedimento.$error,
            }" name="filterProcedimento" :disabled="disableProcedureField" @focus="
              filterProcedimento(' ')
            showProcedimentoFilter = true
              " />
            <div class="filtered-select" v-if="showProcedimentoFilter">
              <ul>
                <li v-for="(tabelaPreco, index) of filteredProcedimentos" :key="index" @click="
                  selectProcedimento(
                    tabelaPreco ? tabelaPreco.procedimento : {}
                  )
                  ">{{
                    tabelaPreco ? tabelaPreco.procedimento.descricao : ''
                  }}</li>
              </ul>
            </div>
          </div>

          <div v-else>
            <b-form-input v-for="procedimento of filterProcedimentoText" disabled :key="procedimento._id"
              name="filterProcedimento" v-model="procedimento.descricao" />
          </div>
        </b-form-group>

        <b-row>
          <div class="col-6">
            <b-form-group label="Data">
              <b-form-datepicker :state="validateState('dataHora')" :class="{
                'is-invalid': formsubmit && $v.formAgendamento.dataHora.$error,
              }" :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-Br" v-model="formAgendamento.dataHora" :min="new Date()">
                <template v-slot:button-content>
                  <b-icon icon="calendar" variant="primary"></b-icon>
                </template>
              </b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-6">


            <b-form-group label="Horário">
              <b-form-input v-model="formAgendamento.horario" v-mask="formAgendamento.horario
                ? formAgendamento.horario.length <= 4
                  ? '#:##'
                  : '##:##'
                : '#:##'
                " :state="validateState('horario')" :class="{
                  'is-invalid': formsubmit && $v.formAgendamento.horario.$error,
                }" locale="pt-Br">
              </b-form-input>
            </b-form-group>
          </div>

        </b-row>



        <b-form-group label="Valor">
          <b-form-input :key="valorKey" v-model="formAgendamento.valor" disabled :state="validateState('especialidade')"
            :class="{
              'is-invalid':
                formsubmit && $v.formAgendamento.especialidade.$error,
            }">
          </b-form-input>
        </b-form-group>

        <b-form-group label="Telefone">
          <b-form-input v-model="formAgendamento.telefone" v-mask="formAgendamento.telefone
            ? formAgendamento.telefone.length <= 14
              ? '(##) ####-####'
              : '(##) # ####-####'
            : '(##) ####-####'
            " :state="validateState('telefone')" :class="{
              'is-invalid': formsubmit && $v.formAgendamento.telefone.$error,
            }">
          </b-form-input>
        </b-form-group>

        <b-row>
          <div class="col-6">
            <b-form-group label="Esse agendamento é recorrente?">
              <b-form-select v-model="formAgendamento.recorrencia" :options="recorencias"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group label="Repetir quantas vezes?">
              <b-form-input v-model="formAgendamento.repeteRecorrencia" type="number">
              </b-form-input>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="form-control" @click="validateForm" :disabled="isProcessingAgendamento">
              <template v-if="isProcessingAgendamento">
                <b-spinner small class="mr-2"></b-spinner> Processando agendamento...
              </template>
              <template v-else>
                Agendar
              </template>
            </b-button>
          </b-col>
          <b-col>
            <b-button class="form-control" variant="light" @click="closeForm">
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal id="confirmar-agendamento" centered title="Confirmar Agendamento" hide-footer>
      <div class="d-flex flex-column">
        <b-form-group label="Procedimento">
          <div v-for="(procedimento, index) of confirmAgendamento.procedimento" :key="index">
            <b-form-input v-if="procedimento" disabled name="filterProcedimento"
              v-model="procedimento.descricao"></b-form-input>
          </div>
        </b-form-group>
        <b-form-group label="Data">
          <b-form-datepicker :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }" v-model="confirmAgendamento.dataHora" disabled locale="pt-Br">
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
        <b-form-group label="Horário">
          <b-form-input v-model="confirmAgendamento.horario" disabled locale="pt-Br">
          </b-form-input>
        </b-form-group>
        <b-form-group label="Confirmar Senha">
          <b-form-input type="password" v-model="confirmAgendamento.senha"></b-form-input>
        </b-form-group>
      </div>
      <div class="d-flex">
        <b-button class="mr-3 mt-3" block @click="confirmarAgendamento">Confirmar</b-button>
      </div>
    </b-modal>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja cancelar este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <!-- <b-toast
      id="toast-processamento"
      no-auto-hide
      v-if="isProcessingAgendamento"
      visible
      variant="info"
      solid
      toaster="b-toaster-bottom-center"
    >
      <template #toast-title>
        <span>Processamento</span>
      </template>
      Processando o agendamento, por favor aguarde...
    </b-toast> -->
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'

import agendaMedicaMixin from '@/src/mixins/agendaMedicaMixin'
import conveniadoMixin from '@/src/mixins/conveniadoMixin'
import especialidadeMixin from '@/src/mixins/especialidadeMixin'
import unidadeMixin from '@/src/mixins/unidadeMixin'
import clienteMixin from '@/src/mixins/clienteMixin'
import moment from 'moment'
import procedimentosMixin from '@/src/mixins/procedimentosMixin'
import alertMixin from '@/src/mixins/alertMixin'
import VueHtml2pdf from 'vue-html2pdf'
import RelAutorizacaoProcedimento from '@/src/router/views/pages/agenda/rel_autorizacao_procedimento.vue'
import Pagamentos from '@/src/services/pagamento'
import { addDays, compareAsc, isSameDay } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import { debounce } from 'lodash'

export default {
  components: { Layout, HeaderPage, VueHtml2pdf, RelAutorizacaoProcedimento },
  mixins: [
    agendaMedicaMixin,
    conveniadoMixin,
    especialidadeMixin,
    unidadeMixin,
    clienteMixin,
    procedimentosMixin,
    alertMixin,
  ],
  data() {
    const todos = [
      {
        description: '',
        isComplete: false,
        dates: { weekdays: 6 },
        color: 'red',
      },
    ]
    return {
      selected: null,
      options: [
        { value: 'Vaga Aberta', text: 'Vaga Aberta' },
        { value: 'Vaga em Negociação', text: 'Vaga em Negociação' }
      ],
      disableProcedureField: false,
      htmlToPdfOptions: {
        margin: [12, 12, 12, 12],

        filename: `autorizacao-procedimento.pdf`,

        image: {
          type: 'jpeg',
          quality: 0.98,
        },

        enableLinks: false,

        html2canvas: {
          scale: 2,
          bottom: 20,
        },

        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
        },
      },
      timezone: 'pt-br',
      confirmAgendamento: {},
      isLoading: false,
      conveniadoSelected: '',
      conveniados: [
        { text: 'Selecione o conveniado', value: '', disabled: true },
      ],
      especialidadeSelected: '',
      especialidades: [
        { text: 'Selecione a especialidade', value: '', disabled: true },
      ],
      unidadeSelected: '',
      dateSelected: this.formatDateSearch(new Date()),
      unidades: [{ text: 'Selecione a unidade', value: '', disabled: true }],
      recorencias: [{ text: 'Selecione', value: '', disabled: true }, { text: 'Semanal', value: 'semanal' }, { text: 'Quizenal', value: 'quinzenal' }, , { text: 'Mensal', value: 'mensal' }],

      formAgendamento: {
        cliente: '',
        unidade: '',
        conveniado: '',
        especialidade: '',
        dataHora: '',
        recorrencia: '',
        repeteRecorrencia: ''
      },
      pageTitles: {
        title: 'Agenda Médica',
      },
      incId: todos.length,
      todos,
      currentPage: 1,
      clientes: [],
      itemId: '',
      modal: false,
      formAgendamentoCliente: '',
      filteredClientes: [],
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      showClienteFilter: false,
      filteredConveniados: [],
      filterConveniadoText: '',
      filterProcedimentoText: '',
      showConveniadoFilter: false,
      showFormConveniadoFilter: false,
      showProcedimentoFilter: false,
      filteredProcedimentos: [],
      unidadesConveniado: [],
      telefones: [],
      rows: 0,
      valorKey: 0,
      idRetorno: '',
      originalReturnDate: '',
      formsubmit: false,
      clienteRoute: '',
      daysWithScheduling: [],
      calendarShow: false,
      clienteSelected: {},
      status: false,
      user: {},
      isProcessingAgendamento: false,
      paramFilterCliente: '',
      filteredClientes: [],
      showClienteFilter: false,
    }
  },
  computed: {
    attributes() {
      return [
        ...this.todos.map((todo) => ({
          dates: todo.dates,
          dot: {
            color: todo.color,
            class: todo.isComplete ? 'opacity-75' : '',
          },
          popover: {
            label: todo.description,
            visibility: 'click',
          },
          customData: todo,
        })),
      ]
    },
  },
  watch: {
    status() {
      if (this.formAgendamento.conveniado) this.getDaysWithScheduling()
    },
    currentPage() {
      this.loadAgenda()
    },
    'formAgendamento.conveniado'() {
      this.unidadesConveniado = this.formAgendamento.conveniado
        ? this.formAgendamento.conveniado.limite.map((item) => {
          return item.unidade
        })
        : []

      this.formAgendamento.especialidade = this.formAgendamento.conveniado
        .especialidade
        ? this.formAgendamento.conveniado.especialidade._id
        : ''
      this.filterProcedimento()
      this.formAgendamento.prazoRetorno = this.formAgendamento.conveniado
        ? this.formAgendamento.conveniado.prazoRetorno
        : 0
    },
    conveniadoSelected() {
      this.unidades = []
      this.unidadeSelected = this.conveniadoSelected.local
    },
    formAgendamentoCliente() {
      this.filterCliente(this.formAgendamentoCliente)
      this.showClienteFilter = true
    },
    filterConveniadoText() {
      this.filterConveniado(this.filterConveniadoText)
      this.showConveniadoFilter = true
      this.showFormConveniadoFilter = true
    },
    filterProcedimentoText() {
      this.filterProcedimento(this.filterProcedimentoText)
      this.showProcedimentoFilter = true
    },
  },
  validations: {
    formAgendamento: {
      cliente: { required },
      conveniado: { required },
      unidade: { required },
      procedimento: { required },
      especialidade: { required },
      dataHora: { required },
      horario: { required },
      valor: { required },
      telefone: { required },
    },
  },
  async created() {
    this.user = this.$store.state.auth.currentUser.usuario

    await this.loadAgenda()
  },
  mounted() {
    this.loadAllAttributes()
    //this.listando()
    this.checkIfHasIdSchedule()
    this.checkIfHasReturn()
  },
  methods: {
    dateClass(ymd, date) {
      let checkIsEqual = this.daysWithScheduling.some((i) => {
        return (
          isSameDay(new Date(ymd), new Date(i)) &&
          isSameDay(new Date(ymd), new Date(i)) &&
          isSameDay(new Date(ymd), new Date(i))
        )
      })
      return checkIsEqual ? 'table-info' : ''
    },
    getDaysWithScheduling() {
      this.isLoading = true
      if (this.conveniadoSelected)
        this.findDaysWitScheduling(
          this.conveniadoSelected._id,
          this.status
        ).then((response) => {
          this.daysWithScheduling = response.data
          this.isLoading = false
        })
    },
    findDependenteByClienteArray(id, cliente) {
      if (cliente) {
        const dependente = cliente.dependentes.find(
          (i) => i._id === id._id || i._id === id
        )
        return dependente ? dependente : {}
      }
      return {}
    },
    findDependente(id, agendamento) {
      let cliente = agendamento.cliente
      if (cliente) {
        const dependente =
          cliente.dependentes[
          cliente.dependentes.findIndex((i) => {
            return i._id === id
          })
          ]
        return dependente || null
      } else return null
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formAgendamento[name]
      return $dirty ? !$error : null
    },
    async checkIfHasReturn() {
      this.disableProcedureField = false
      let scheduleId = this.$route.query.retorno

      if (scheduleId) {
        const { data: scheduling } = await this.findById(scheduleId)
        const procedures = scheduling.procedimento
        let procedureNameInLIst = ''

        if (procedures.length) {
          const procedureName = procedures[0].descricao.trim()
          const procedureNameSplit = procedureName.split(' ')
          procedureNameSplit.shift()
          procedureNameSplit.unshift('Retorno')
          procedureNameInLIst = procedureNameSplit
        }

        if (scheduling.retornado) {
          this.$router.push({
            path: '/agenda/agenda-medica',
          })
        }

        if (!scheduling.retornado) {
          const procedureFromReturn = await this.findOneByDescription(
            procedureNameInLIst
          )

          if (procedureFromReturn) {
            this.disableProcedureField = true
            this.modalRetorno({
              ...scheduling,
              procedimento: [procedureFromReturn],
            })
          }

          if (!procedureFromReturn) {
            this.modalRetorno({ ...scheduling, procedimento: [] })
          }
        }
      }
    },
    checkIfHasIdSchedule() {
      let scheduleId = this.$route.query.agendamento
      if (scheduleId) {
        this.findById(scheduleId, true).then((response) => {
          this.modalEdit(response.data)
        })
      }
    },
    getRouteUser() {
      this.clienteRoute = this.$route.query.cliente
      if (this.clienteRoute) {
        let cliente = this.clientes[
          this.clientes.findIndex((i) => i._id === this.clienteRoute)
        ]
        this.formAgendamentoCliente = cliente.nome
        this.filteredClientes = cliente.dependentes
          ? cliente.dependentes.map((i) => {
            return {
              nome: i.dependente,
              tipo: 'dependente',
              titular: cliente._id,
            }
          })
          : []
        this.filteredClientes.push(cliente)
        setTimeout(() => {
          this.showClienteFilter = true
          this.formAgendamento.cliente = this.clienteRoute
          this.filteredClientes = this.clientes.filter(
            (i) => i.titular === this.clienteRoute
          )
          this.filteredClientes.push(cliente)
          this.$bvModal.show('novo-agendamento')
        }, 100)
      }
    },
    modalRetorno(agendamento) {
      this.formAgendamento = {
        cliente: agendamento.cliente ? agendamento.cliente._id : null,
        unidade: agendamento.unidade,
        especialidade: agendamento.especialidade
          ? agendamento.especialidade._id
          : null,
        conveniado: agendamento.conveniado,
        dataHora: agendamento.dataHora,
        horario: agendamento.horario,
        procedimento: agendamento.procedimento,
        tipo: 'retorno',
      }

      this.idRetorno = agendamento._id
      this.originalReturnDate = agendamento.dataHora
      if (this.conveniadoSelected)
        this.formAgendamento.conveniado = this.conveniadoSelected
      else if (this.formAgendamento.conveniado)
        this.selectConveniado(this.formAgendamento.conveniado)

      this.formAgendamentoCliente = agendamento.cliente
        ? agendamento.cliente.nome
        : ''
      setTimeout(() => {
        this.showClienteFilter = false
      }, 100)
      this.selectProcedimento(
        agendamento.procedimento ? agendamento.procedimento : {}
      )

      this.$bvModal.show('novo-agendamento')
    },
    selectConveniadoByRoute() {
      let conveniadoId = this.$route.query.conveniado
      if (conveniadoId) {
        let conveniado = this.findConveniado(conveniadoId)
        this.selectConveniado(conveniado)
      }
    },
    selectConveniado(conveniadoId) {
      this.isLoading = true
      this.findOneConveniado(
        conveniadoId._id ? conveniadoId._id : conveniadoId,
        true
      ).then((response) => {
        const conveniado = response.data
        this.conveniadoSelected = conveniado
        this.formAgendamento.conveniado = conveniado
        this.formAgendamento.local = conveniado.local
        this.filterConveniadoText = conveniado.nome
        this.getDaysWithScheduling()
        setTimeout(() => {
          this.showConveniadoFilter = false
          this.showFormConveniadoFilter = false
          this.isLoading = false
        }, 100)
      })
    },
    filterConveniado(filter) {
      if (!filter) {
        this.filteredConveniados = this.conveniados.slice(0, 4)
        return
      }

      this.filteredConveniados = this.conveniados
        .filter(
          (i) =>
            i.nome.toLowerCase().includes(filter.toLowerCase()) ||
            (i.registro ? i.registro.toLowerCase() : '').includes(
              filter.toLowerCase()
            )
        )
        .slice(0, 4)
    },
    async selectProcedimento(procedimento) {
      if (procedimento instanceof Array) {
        if (procedimento.length > 1) {
          this.formAgendamento.procedimento = procedimento
          this.filterProcedimentoText =
            procedimento instanceof Array
              ? procedimento.map((i) => (i ? i : {}))
              : procedimento.descricao
        } else {
          if (procedimento[0])
            this.formAgendamento.procedimento = procedimento[0]
          this.filterProcedimentoText = procedimento[0]
            ? procedimento[0].descricao
            : ''
        }
      } else {
        this.formAgendamento.procedimento = procedimento
        this.filterProcedimentoText = procedimento ? procedimento.descricao : ''
      }
      if (
        this.formAgendamento.conveniado &&
        !(this.formAgendamento.procedimento instanceof Array)
      ) {
        let precoPlano = 0
        this.formAgendamento.valor = 0
        let tabelaPreco = {}

        this.findOneTabela(
          this.formAgendamento.conveniado._id,
          this.formAgendamento.procedimento._id
        ).then((conveniadoTabela) => {
          tabelaPreco = conveniadoTabela.data.tabelaPreco[0]
        })

        // let tabelaPreco = this.formAgendamento.conveniado.tabelaPreco[this.getProcedureIndexById(this.formAgendamento.procedimento._id)]

        if (this.findCliente(this.formAgendamento.cliente)) {
          this.clienteSelected = await this.findCliente(
            this.formAgendamento.cliente
          )
          if (this.formAgendamento.dependente) {
            let dependnetePlano = this.findDependenteByClienteArray(
              this.formAgendamento.dependente,
              this.clienteSelected
            ).plano

            precoPlano =
              tabelaPreco.precoPorPlano[
              tabelaPreco.precoPorPlano.findIndex((i) => {
                return i.plano._id === dependnetePlano._id
              })
              ]
          } else
            precoPlano =
              tabelaPreco.precoPorPlano[
              tabelaPreco.precoPorPlano.findIndex((i) => {
                return i.plano._id === this.clienteSelected.plano._id
              })
              ]
          this.formAgendamento.valorReal = tabelaPreco
            ? tabelaPreco.custoProcedimento
            : 0
          this.formAgendamento.valor = this.formAgendamento.valor
            ? this.formAgendamento.valor
            : precoPlano.preco
        }
        if (!precoPlano) precoPlano = {}

        if (precoPlano && !this.formAgendamento.valor) {
          this.formAgendamento.valor = this.formAgendamento.valor
            ? this.formAgendamento.valor
            : 0
        }
      }
      setTimeout(() => {
        this.showProcedimentoFilter = false
        this.valorKey += 1
      }, 100)
    },
    filterProcedimentos(procedimentos) {
      let verifiedProcediemntos = []
      let plano = this.clienteSelected ? this.clienteSelected.plano : null
      if (this.formAgendamento.dependente)
        plano = this.findDependenteByClienteArray(
          this.formAgendamento.dependente,
          this.clienteSelected
        ).plano
      if (procedimentos && procedimentos.length) {
        for (let i = 0; i < procedimentos.length; i++) {
          if (procedimentos[i] && plano) {
            let precosPorPlano = procedimentos[i]['precoPorPlano']
            if (precosPorPlano) {
              let precoPorPlano =
                precosPorPlano[
                precosPorPlano.findIndex((precoPlano) =>
                  precoPlano ? precoPlano.plano._id == plano._id : false
                )
                ]
              if (precoPorPlano.preco)
                precoPorPlano.preco = precoPorPlano.preco.replace(',', '.')
              if (parseFloat(precoPorPlano.preco) > 0) {
                verifiedProcediemntos.push(procedimentos[i])
              }
            }
          }

          if (i >= procedimentos.length - 1) {
            return verifiedProcediemntos
          }
        }
      } else return []
    },
    debounceSearchProcedimento: debounce(function (filter) {
      if (!filter) return

      this.searchProcedimentoInTabelaByName(
        this.formAgendamento.conveniado._id,
        filter
      ).then((response) => {
        this.filteredProcedimentos = this.filterProcedimentos(response.data)
      })
    }, 300),
    async filterProcedimento(filter) {
      await this.debounceSearchProcedimento(filter)
    },
    async selectCliente(cliente) {
      if (cliente['tipo'] === 'dependente') {
        this.formAgendamento.dependente = cliente
        this.formAgendamento.cliente = cliente.titular
        if (cliente.plano)
          this.formAgendamento.plano = cliente.plano._id
            ? cliente.plano._id
            : cliente.plano
        this.clienteSelected = await this.findCliente(cliente.titular)
        this.formAgendamentoCliente = cliente.dependente
        this.paramFilterCliente = cliente.nome;
        this.showClienteFilter = false;
        this.filteredClientes = [];
      } else {
        this.clienteSelected = await this.findCliente(cliente._id)
        this.formAgendamento.cliente = cliente._id
        if (cliente.plano)
          this.formAgendamento.plano = cliente.plano._id
            ? cliente.plano._id
            : cliente.plano

        delete this.formAgendamento.dependente
        this.formAgendamentoCliente = cliente.nome
        this.paramFilterCliente = cliente.nome;
        this.showClienteFilter = false;
        this.filteredClientes = [];
      }
      setTimeout(() => {
        this.showClienteFilter = false
        if (this.formAgendamento.procedimento)
          this.selectProcedimento(this.formAgendamento.procedimento)
      }, 100)
    },
    filterCliente(filter) {
      if (!filter) {
        this.filteredClientes = this.clientes.slice(0, 4)
        return
      }

      this.filteredClientes = this.clientes
        .filter((i) => {
          return (
            (i.nome
              ? i.nome.toLowerCase().includes(filter.toLowerCase())
              : false) ||
            (i.cartao
              ? i.cartao.toLowerCase().includes(filter.toLowerCase())
              : false)
          )
        })
        .slice(0, 4)
    },
    findCliente(id) {
      this.isLoading = true
      if (id !== undefined)
        return this.findOneCliente(id).then((response) => {
          this.isLoading = false
          return response.data
        })
    },
    findConveniado(id) {
      return this.conveniados[this.conveniados.findIndex((i) => i._id === id)]
    },
    async savePhone() {
      let cliente = this.findCliente(this.formAgendamento.cliente)
      if (!cliente.telefones) cliente.telefones = []

      cliente.telefones.push({
        descricao: 'Telefone Pessoal',
        numero: this.formAgendamento.telefone,
      })
      await this.editCliente(this.formAgendamento.cliente, cliente)
    },
    getProcedureIndexById(id) {
      return id
        ? this.formAgendamento.conveniado.tabelaPreco.findIndex((i) =>
          i ? i.procedimento._id === id : 0
        )
        : 0
    },
    openModal() {
      if (
        moment(this.dateSelected).isSameOrAfter(
          new Date().setUTCHours(0, 0, 0, 0)
        )
      ) {
        delete this.formAgendamento._id
        this.formAgendamento.conveniado = ''
        if (this.conveniadoSelected) {
          this.formAgendamento.conveniado = this.conveniadoSelected

          /*

            Não será utilizado

          this.findOneTabela(this.formAgendamento.conveniado._id, null, true).then(conveniadoTabela => {
            this.formAgendamento.conveniado['tabelaPreco'] = conveniadoTabela.data.tabelaPreco
          })
          */

          this.formAgendamento.especialidade = this.formAgendamento.conveniado
            .especialidade
            ? this.formAgendamento.conveniado.especialidade._id
            : ''
        }
        if (this.dateSelected) this.formAgendamento.dataHora = this.dateSelected
        this.formAgendamentoCliente = ''
        setTimeout(() => {
          this.showClienteFilter = false
        }, 100)
        this.formsubmit = false
        this.$bvModal.show('novo-agendamento')
      }
    },
    getMedicoInfo() {
      let conveniado = this.conveniados[
        this.conveniados.findIndex(
          (conveniado) => conveniado._id === this.preAgendamento.conveniado
        )
      ]
      this.preAgendamento.local = conveniado ? conveniado.local : ''
    },
    handleDelete() {
      this.isLoading = true
      this.deleteAgendaMedica(this.itemId)
        .then((response) => {
          this.modal = false
          this.loadAgenda()
        })
        .catch((error) => {
          this.errorMessage(
            error.response.data
              ? error.response.data.message
              : 'Erro inesperado.'
          )
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    modalDelete(item) {
      this.modal = true
      this.itemId = item
    },
    searchByFilter() {
      if (this.conveniadoSelected && this.dateSelected) this.loadAgenda()
    },
    formatDate(date) {
      if (date) return moment(date).format('hh:MM')
    },
    formatDateSearch(date) {
      if (date) return moment(date).format('YYYY-MM-DD')
    },
    listandoClientes() {
      if (this.paramFilterCliente.length < 3) {
        this.filteredClientes = []; // Esvazia a lista se menos de 3 caracteres
        return;
      }

      // Chama o método para carregar os clientes
      this.loadClientesBySelectByText(this.paramFilterCliente)
        .then((clientes) => {
          this.clientes = [];

          // Adiciona os clientes e seus dependentes à lista
          for (let cliente of clientes) {
            this.clientes.push(cliente);
            for (let dependente of cliente.dependentes) {
              dependente['nome'] = dependente.dependente;
              dependente['tipo'] = 'dependente';
              dependente['titular'] = cliente._id;
              this.clientes.push(dependente);
            }
          }

          // Filtra os clientes com base no input
          this.filteredClientes = this.clientes.filter((cliente) =>
            cliente.nome.toLowerCase().includes(this.paramFilterCliente.toLowerCase())
          );

          // Esconde o filtro se não houver clientes
          if (this.filteredClientes.length === 0) {
            this.showClienteFilter = false;
          }
        })
        .catch(() => {
          this.errorMessage('Ops... Não conseguimos atender sua solicitação :(');
        });
    },

    // // Quando o cliente é selecionado
    // selectCliente(cliente) {
    //   this.paramFilterCliente = cliente.nome;
    //   this.showClienteFilter = false;
    //   this.filteredClientes = [];
    //   this.$emit('clientSelected', cliente);
    //   this.getRouteUser()
    //   this.filterCliente(this.paramFilterCliente)
    // },

    listandoOld() {
      this.isLoading = true
      this.clientes = []
      this.loadClientesBySelect()
        .then((clientes) => {
          for (let cliente of clientes) {
            this.clientes.push(cliente)
            for (let dependente of cliente.dependentes) {
              dependente['nome'] = dependente.dependente
              dependente['tipo'] = 'dependente'
              dependente['titular'] = cliente._id
              this.clientes.push(dependente)
            }
          }
          this.getRouteUser()
          this.filterCliente(this.formAgendamentoCliente)
        })
        .catch((err) => {
          console.log(err)
          this.errorMessage('Ops... Não conseguimos atender sua solicitação :(')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadAllAttributes() {
      this.loadConveniadosBySelect().then((conveniados) => {
        this.conveniados = conveniados
        let user = localStorage.getItem('auth.currentUser')
        if (user) user = JSON.parse(user)
        if (user.usuario.conveniado) {
          this.conveniados = conveniados.filter(
            (i) => i._id === user.usuario.conveniado
          )
        }
        this.filterConveniado()
      })
      this.loadEspecialidades().then((especialidades) => {
        especialidades.map((especialidade) => {
          this.especialidades.push({
            text: especialidade.descricao,
            value: especialidade._id,
          })
        })
      })
    },
    loadAgenda() {
      this.isLoading = true

      const user = this.user
      const typeOfUserIsEqualToContractedSecretary =
        user.tipo === 'secretaria_conveniado'

      const contractedId = typeOfUserIsEqualToContractedSecretary
        ? { _id: user['conveniado'] ? user.conveniado : null }
        : this.conveniadoSelected

      this.loadAgendaMedica(
        contractedId,
        this.unidadeSelected,
        this.dateSelected,
        this.currentPage,
        this.status
      ).then((data) => {
        this.agenda = data.agendamentos
        this.rows = data.total
      })

      this.isLoading = false
    },
    async modalShowReport(agendamento) {
      this.confirmAgendamento = agendamento
      this.confirmAgendamento.cliente = await this.findCliente(
        this.formAgendamento.cliente
      )
      this.confirmAgendamento.conveniado = !this.formAgendamento.conveniado._id
        ? (await this.findOneConveniado(this.formAgendamento.conveniado)).data
        : this.formAgendamento.conveniado
      this.$bvModal.show('autorizacaoProcedimento')
    },
    modalConfirmarAgenda(agendamento) {
      this.confirmAgendamento = agendamento
      this.$bvModal.show('confirmar-agendamento')
    },
    confirmarAgendamento() {
      if (this.confirmAgendamento.conveniado)
        this.confirmAgendamento.conveniado = this.confirmAgendamento.conveniado
          ._id
          ? this.confirmAgendamento.conveniado._id
          : this.confirmAgendamento.conveniado
      this.isLoading = true
      this.confirmAgendaMedica(this.confirmAgendamento)
        .then((response) => {
          this.isLoading = false
          this.loadAgenda()
        })
        .catch((error) => {
          this.$bvToast.toast(
            error.response.data
              ? error.response.data.message
              : 'Erro inesperado.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = false
        })
      this.$bvModal.hide('confirmar-agendamento')
    },
    invalidForm() {
      this.formsubmit = true
    },
    async validateForm() {
      this.$v.$touch();

      if (!this.$v.formAgendamento.$error) {

        this.isProcessingAgendamento = true;
        try {
          if (this.formAgendamento._id) {
            await this.editAgenda();
          } else {
            await this.agendar();
          }
        } finally {
          this.isProcessingAgendamento = false;
        }
      } else {
        this.invalidForm();
      }

      this.disableProcedureField = false;
    },
    closeForm() {
      this.disableProcedureField = false
      this.$bvModal.hide('novo-agendamento')
    },
    modalEdit(agendamento) {
      console.log(agendamento);
      if (agendamento.status_atendimento === 'Vaga em Negociação') {
        this.errorMessage('Essa vaga consta em em negociação.')
        return;
      }
      let scheduleId = this.$route.query.agendamento
      this.formsubmit = false
      this.formAgendamento = {
        _id: agendamento._id,
        cliente: agendamento.cliente ? agendamento.cliente._id : null,
        plano: agendamento.plano,
        unidade: agendamento.unidade,
        especialidade: agendamento.especialidade
          ? agendamento.especialidade._id
          : null,
        conveniado: agendamento.conveniado,
        dataHora: agendamento.dataHora,
        horario: agendamento.horario,
        status: agendamento.status,
        procedimento: agendamento.procedimento,
        telefone: agendamento.telefone,
        dependente: agendamento.dependente,
        valor: agendamento.valor
          ? agendamento.valor.replace('R$ ', '')
          : agendamento.valor,
      }
      if (this.conveniadoSelected) {
        this.formAgendamento.conveniado = this.conveniadoSelected
        this.findOneTabela(
          this.formAgendamento.conveniado._id,
          null,
          true
        ).then((conveniadoTabela) => {
          this.formAgendamento.conveniado['tabelaPreco'] =
            conveniadoTabela.data.tabelaPreco
        })
      }
      this.formAgendamentoCliente = agendamento.cliente
        ? agendamento.cliente.nome
        : ''
      setTimeout(() => {
        this.showClienteFilter = false
      }, 100)
      if (agendamento.dependente) {
        let dependente = this.findDependente(
          agendamento.dependente,
          agendamento
        )
        console.log(dependente);
        if (dependente !== undefined && dependente !== null) {
          dependente.tipo = 'dependente'
          dependente.titular = agendamento.cliente
            ? agendamento.cliente._id
            : null
          this.selectCliente(dependente || {})
        }
      } else this.selectCliente(agendamento.cliente ? agendamento.cliente : {})
      if (agendamento.conveniado)
        this.selectConveniado(
          agendamento.conveniado ? agendamento.conveniado : {}
        )
      if (!scheduleId)
        this.selectProcedimento(
          agendamento.procedimento ? agendamento.procedimento : {}
        )
      this.$bvModal.show('novo-agendamento')
    },
    setSchedulingReturned() {
      if (this.idRetorno)
        this.editAgendaMedica(this.idRetorno, { retornado: true })
          .then((response) => {
            this.loadAgenda()
          })
          .catch((err) => {
            this.errorMessage(
              err.response.data.message
                ? err.response.data.message
                : 'Erro inesperado.'
            )
          })
    },

    async editAgenda() {
      let scheduleId = this.$route.query.agendamento;

      // Verifica o saldo do cliente antes de prosseguir
      if (this.formAgendamento.valor > this.findCliente(this.formAgendamento.cliente).saldo) {
        this.errorMessage('Saldo insuficiente.');
        return;
      }

      // Se houver um conveniado, pega o `_id`
      if (this.formAgendamento.conveniado) {
        this.formAgendamento.conveniado = this.formAgendamento.conveniado._id
          ? this.formAgendamento.conveniado._id
          : this.formAgendamento.conveniado;
      }

      this.isLoading = true; // Ativa o estado de carregamento

      try {
        // Usa await para aguardar a chamada de editAgendaMedica
        await this.editAgendaMedica(this.formAgendamento._id, this.formAgendamento);

        // Verifica se o ID do agendamento é o mesmo
        if (scheduleId === this.formAgendamento._id) {
          this.modalShowReport(this.formAgendamento);
        }

        // Esconde o modal de novo agendamento
        this.$bvModal.hide('novo-agendamento');

        // Reseta o formulário de agendamento
        this.formAgendamento = {};

        // Recarrega a agenda
        await this.loadAgenda(); // Usa await para garantir que loadAgenda seja completado
      } catch (err) {
        // Lida com o erro
        this.errorMessage(
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Erro inesperado.'
        );
      } finally {
        // Desativa o estado de carregamento independentemente do sucesso ou erro
        this.isLoading = false;
      }
    },

    async getSituacao(clienteId) {
      if (clienteId) {
        this.isLoading = true
        return (await Pagamentos.getSituacao(clienteId)).data.situacao
      }
    },
    async agendar() {
      if (this.formAgendamento.conveniado) {
        this.formAgendamento.conveniado = this.formAgendamento.conveniado._id
          ? this.formAgendamento.conveniado._id
          : this.formAgendamento.conveniado;
      }

      // Busca informações do cliente
      let cliente = await this.findCliente(this.formAgendamento.cliente);
      this.isLoading = true;

      // Verifica se o saldo é suficiente
      if (this.formAgendamento.valor > cliente.saldo) {
        this.errorMessage('Saldo insuficiente.');
        this.isLoading = false;
        return;
      }

      // Verifica se o cliente está com a situação "Em dia"
      if ((await this.getSituacao(this.formAgendamento.cliente)) !== 'Em dia') {
        this.errorMessage('Este cliente não está com a mensalidade em dia.');
        this.isLoading = false;
        return;
      }

      // Verifica se o cliente está ativo
      if (cliente.situacao !== 'ativo') {
        this.errorMessage('Este cliente se encontra inativo/cancelado.');
        this.isLoading = false;
        return;
      }

      // Se o tipo de agendamento for 'retorno', verificar limites de data
      if (this.formAgendamento.tipo === 'retorno') {
        let conveniado = await this.findOneConveniado(this.formAgendamento.conveniado);

        let limite = addDays(
          new Date(this.originalReturnDate),
          conveniado && conveniado.data && conveniado.data.prazoRetorno
            ? conveniado.data.prazoRetorno
            : 0
        );

        // Verifica se a data está dentro do limite de consulta
        if (compareAsc(limite, new Date(this.formAgendamento.dataHora)) < 0) {
          this.errorMessage('Esta data está fora do limite de consulta.');
          this.isLoading = false;
          return;
        }
      }

      try {
        // Registra a agenda médica e aguarda a conclusão
        await this.registerAgendaMedica(this.formAgendamento);

        // Fecha o modal e mostra o relatório do agendamento
        this.$bvModal.hide('novo-agendamento');
        this.modalShowReport(this.formAgendamento);
        this.setSchedulingReturned();

        // Recarrega a agenda
        await this.loadAgenda();
      } catch (err) {
        // Lida com possíveis erros
        this.errorMessage(
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Erro inesperado.'
        );
      } finally {
        // Finaliza o estado de carregamento
        this.isLoading = false;
      }
    },
    async print(field) {
      await this.$htmlToPaper(field)
    },
    generateReport(ref) {
      this.$refs[ref].generatePdf()
    },
    isOnline(unidade) {
      alert(unidade === 'online');
      return unidade === 'online';
    },
    async updateStatus(id, status_atendimento) {
      await this.updateStatusService(id, status_atendimento)
    },
    onContext(ctx) {
      this.context = ctx
      alert()
    }
  },
}
</script>

<style src="../style.scss" lang="scss" scoped></style>
<style scoped>
.filtered-select {
  position: absolute;
  background-color: white;
  width: 95%;
  left: 10;
  z-index: 100;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  padding: 5px 0;
}

.filtered-select ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.filtered-select ul li {
  padding: 12px 16px;
  font-size: 14px;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.filtered-select ul li:hover {
  background-color: #0088a8;
  color: white;
}

.filtered-select ul li:active {
  background-color: #006f85;
}

.absolute {
  position: absolute;
  z-index: 100;
}

.font-large {
  font-size: 1rem;
}
.b-form-input {
  width: 100%;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 14px;
}
</style>
